import {Component} from 'react'
import './index.css'
import DestinationItem from '../DestinationItem'

class DestinationSearch extends Component {
  state = {searchInput: '', toBeDisplayed: this.props}

  onSearch = event => {
    this.setState({searchInput: event.target.value})
  }

  render() {
    const {searchInput, toBeDisplayed} = this.state
    const k = toBeDisplayed.destinationsList
    const searchResults = k.filter(each =>
      each.name.toLowerCase().includes(searchInput.toLowerCase()),
    )

    return (
      <div className="main-container">
        <div className="sub-cont1">
          <h1 className="header-prop">Destination Search</h1>

          <div className="icon1">
            <input
              onChange={this.onSearch}
              className="ip-prop"
              type="search"
              placeholder="Search"
            />
            <img
              className="icon2"
              src="https://assets.ccbp.in/frontend/react-js/destinations-search-icon-img.png"
              alt="search icon"
            />
          </div>

          <br />
        </div>
        <ul className="sub-cont2">
          {searchResults.map(eachItem => (
            <DestinationItem features={eachItem} key={eachItem.id} />
          ))}
        </ul>
      </div>
    )
  }
}
export default DestinationSearch
